module.exports = __webpack_public_path__ + "static/media/view2.b010cf07.jpg";